import { useMemo } from 'react'

import { FilterDefinition, FiltersDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export type CompanyDocumentsFilterKeys = 'createdAt' | 'visible'

export type CompanyDocumentsFiltersDefinition = FiltersDefinition<CompanyDocumentsFilterKeys>

export function useFilters(): {
  filters: CompanyDocumentsFiltersDefinition
  loading: boolean
} {
  const filters: CompanyDocumentsFiltersDefinition = useMemo(
    () => ({
      createdAt: {
        label: i18n.t('documents.employee.list.created_at'),
        type: 'date',
      } satisfies FilterDefinition,

      visible: {
        label: i18n.t('documents.employee.filters.visibility'),
        type: 'in',
        options: {
          options: [
            {
              label: i18n.t('documents.employee.filters.visible'),
              value: 'true',
            },
            {
              label: i18n.t('documents.employee.filters.hidden'),
              value: 'false',
            },
          ],
        },
      } satisfies FilterDefinition,
    }),
    []
  )

  return { filters, loading: false }
}
